import { render, staticRenderFns } from "./PlayArea.vue?vue&type=template&id=1bb17518&"
import script from "./PlayArea?vue&type=script&lang=ts&"
export * from "./PlayArea?vue&type=script&lang=ts&"
import style0 from "./PlayArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports